import React from 'react';
import { Form, FormikBag, FormikErrors, Field } from 'formik';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { formSchema } from './validations';
import { withFormik } from 'formik';
import { FormikProps } from 'formik';
import { withRouter } from 'react-router-dom';
import { History, Location } from 'history';
import AlertSuccess from '../../components/AlertSuccess';
import { formatMobileNumber } from '../../lib/formatter';
import AlertError from '../../components/AlertError';
import FormikNumberFormatInputField from '../formik/FormikNumberFormatInputField';
import FormLabelAndInput from '../FormLabelAndInput';
import { Context } from '../../types';

const useStyles: any = makeStyles((theme: any) => ({
  verifyAuthCodeFormContainer: {
    '& form': {
      padding: theme.spacing(3, 2.5, 0),
    },
  },
  verifyAuthCodeFormLabelHeadingGrid: {
    '& .MuiTypography-body1': {
      fontSize: '15px !important',
      fontWeight: '500 !important',
      marginTop: theme.spacing(2),
    },
  },
  verifyAuthCodeFormButtonContainer: {
    '& button': {
      margin: theme.spacing(2, 0),
    },
  },
  messageContainer: {
    marginBottom: theme.spacing(1.5),
  },
}));

type FormValues = {
  verificationCode: string;
};

type LoginFormProps = FormikProps<FormValues> &
  FormikErrors<any> & {
    mobileNumber: string;
    values: FormValues;
    isSubmitting: boolean;
    stateError: string;
    context: Context;
    getPaymentsTokenByAuthCode: (values: FormValues, mobileNumber: string) => Promise<any>;
    setLoginStep: (step: number) => void;
    setFieldValue: (fieldName: string, value: any, shouldValidate?: boolean) => void;
    history: History<Location>;
  };

const VerifyAuthCodeForm = (props: LoginFormProps) => {
  const { isSubmitting, mobileNumber, values, stateError } = props;
  const classes = useStyles();
  return (
    <Grid className={classes.verifyAuthCodeFormContainer} container>
      <Grid item xs={12}>
        <Form data-testid='uia-verificationCodeForm' noValidate autoComplete='off'>
          <Grid item xs={12} className={classes.messageContainer}>
            {stateError ? (
              <AlertError message={stateError} data-testid='uia-submit-error' />
            ) : (
              <AlertSuccess message={`A text message with a 6-digit verification code was just sent to ${formatMobileNumber(mobileNumber)}.`} />
            )}
          </Grid>
          <Grid item className={classes.verifyAuthCodeFormLabelHeadingGrid} xs={12}>
            <FormLabelAndInput label='Enter the verification code'>
              <Field
                component={FormikNumberFormatInputField}
                variant='outlined'
                id='verificationCode'
                name='verificationCode'
                placeholder='Enter the 6-digit verification code'
                fullWidth
                pattern='[0-9]{6}'
                format='######'
                InputProps={{
                  disabled: isSubmitting,
                }}
                data-testid='uia-verificationCode'
                value={values.verificationCode}
                formHelperTextClassName={classes.formHelperTextBase}
              />
            </FormLabelAndInput>
          </Grid>
          <Grid container className={classes.verifyAuthCodeFormButtonContainer}>
            <Grid item xs={12}>
              <Button size='large' variant='contained' color='primary' type='submit' disabled={isSubmitting} fullWidth data-testid='uia-continue'>
                Continue
              </Button>
            </Grid>
          </Grid>
        </Form>
      </Grid>
    </Grid>
  );
};

export default withRouter(
  withFormik({
    mapPropsToValues: () => ({
      verificationCode: '',
    }),
    validateOnBlur: false,
    validationSchema: formSchema,
    handleSubmit: (values: any, formikBag: FormikBag<any, any>) => {
      const { props } = formikBag;
      props.setError(null);
      formikBag.setSubmitting(true);

      props.getPaymentsTokenByAuthCode(props.checkOutId, props.mobileNumber, values.verificationCode).then((response: any) => {
        formikBag.setSubmitting(false);
        const { payload } = response;
        if (payload.response && payload.response.status === 400) {
          const message = payload.response.data && payload.response.data.message;
          props.setError(message);
        } else if (payload && payload.status === 200) {
          props.setLoginStep(0);
          if (props.context === Context.checkout) {
            props.history.push('/select-account');
          } else {
            props.history.push('/link-select-account');
          }
        }
      });
    },
  })(VerifyAuthCodeForm)
);
